import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import OperationInputForm from './OperationInputForm';
import SAPEditor from './SAPEditor';
import SAPEditorUsdm from './SAPEditorUsdm';

// SAP Intake Form and SAP Editor are hidden from the UI for now.
// Their components are kept so the tabs can be restored by flipping `hidden` to false.
const SAP_TABS = [
  { label: 'SAP Intake Form', value: 0, hidden: true },
  { label: 'SAP Editor', value: 1, hidden: true },
  { label: 'SAP usdm', value: 2 },
];

const VISIBLE_SAP_TABS = SAP_TABS.filter((t) => !t.hidden);
const DEFAULT_SAP_TAB = VISIBLE_SAP_TABS[0]?.value ?? 0;

const SAPPage = () => {
  const [tab, setTab] = useState(DEFAULT_SAP_TAB);

  // Handler to go to SAP Editor tab
  const goToEditor = () => setTab(1);

  return (
    <Box>
      <Tabs value={tab} onChange={(_, v) => setTab(v)}>
        {VISIBLE_SAP_TABS.map((t) => (
          <Tab key={t.label} label={t.label} value={t.value} />
        ))}
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <OperationInputForm onSuccess={goToEditor} />}
        {tab === 1 && <SAPEditor />}
        {tab === 2 && <SAPEditorUsdm />}
      </Box>
    </Box>
  );
};

export default SAPPage;
